import ReactGA from "react-ga4";

const itIsProductionOrStagingEnv =
  process.env.NODE_ENV === "production" || process.env.NODE_ENV === "staging";

export function gaEvent({ category, action, label, options = {} }) {
  try {
    if (itIsProductionOrStagingEnv) {
      ReactGA.event({ category, action, label, options });
    }
  } catch (err) {
    console.log(err);
  }
}

export function triggerBingAdsEvent(eventName, eventData) {
  if (typeof window === "undefined") {
    return;
  }

  window.uetq = window.uetq || [];
  window.uetq.push("event", eventName, eventData);
}
